import { isUnitTest } from '@/utils/unit.js'

let intervalDuration = 2000
let clearIntervalTimeoutDuration = 5000

if (isUnitTest()) {
  intervalDuration = 500
  clearIntervalTimeoutDuration = 1000
}

export const removeNativeTooltipFromMaterialIconsMixin = {
  mounted() {
    this._fixIconsMixinIntervalFinish = false
    this._fixIconsMixinInterval = setInterval(() => {
      let arr =
        [...(this?.$el || window.document).querySelectorAll('span')] || []
      arr = arr.filter ? arr : [] //not an array
      arr
        .filter((span) => {
          return (
            span.className.includes('material-design-icon') &&
            span.getAttribute('aria-label') !== ''
          )
        })
        .forEach((span) => {
          /*console.log(
            'Remove aria-label from material icon',
            span.getAttribute('aria-label')
          )*/
          span.setAttribute('aria-label', '')
        })

      //Remove title node inside svg path
      ;[
        ...(this?.$el || window.document).querySelectorAll('svg path title'),
      ].forEach((node) => {
        node.parentElement.removeChild(node)
      })
    }, intervalDuration)
    setTimeout(() => {
      clearInterval(this._fixIconsMixinInterval)
      this._fixIconsMixinIntervalFinish = true
    }, clearIntervalTimeoutDuration)
  },
  methods: {
    flushFixIconsInterval() {
      return new Promise((resolve) => {
        let w = setInterval(() => {
          if (this._fixIconsMixinIntervalFinish) {
            clearInterval(w)
            resolve()
          }
        }, 1000)
      })
    },
  },
}

export default {
  removeNativeTooltipFromMaterialIconsMixin,
}
